(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["takumi-country-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function (event) {
  var form = event.target;
  if (form.id !== 'TakumiCountryForm') return;
  var returnTo = form.querySelector('input[name="return_to"]');
  if (!returnTo) {
    returnTo = document.createElement('input');
    returnTo.type = 'hidden';
    returnTo.name = 'return_to';
    form.appendChild(returnTo);
  }
  // Product selection updates the URL after the localization form renders.
  returnTo.value = window.location.pathname + window.location.search + window.location.hash;
});
  } catch(e) { console.error(e); }
})();

})();
